/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Splashscreen.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import $ from 'jquery'
import TweenMax from 'TweenMax'

export default class Splashscreen {
    constructor () {
        this.$cont = $('#splashscreen')
        this.$svg = this.$cont.find('#svg-splashscreen')
        this.$bg = this.$cont.find('#splashscreen-bg')
        this.$subSvg = this.$cont.find('#sub-svg')
        this.$btn = this.$cont.find('#splashscreen-btn')
        this.bgSrc = window.TEMP.baseurl + '/assets/img/splashscreen.jpg'
        this.$body = $(document.body)

        this.isLock = false
        this.setValues()

        // Binded methods
        this.onResize = this.onResize.bind(this)
        this.onBtnClick = this.onBtnClick.bind(this)
    }

    init () {
        return new Promise(resolve => {
            window.addEventListener('resize', this.onResize)
            this.$btn.on('click touch', this.onBtnClick)

            if (window.sessionStorage && window.sessionStorage.getItem('ntm')) {
                this.hide()
                resolve()
            } else {
                this.$body.addClass('splashscreen-visible')
                this.$cont.addClass('initiate')
                resolve()
                // this
                //     .loadBg()
                //     .then(() => {
                //         // Add initiated class
                //         this.$cont.addClass('initiate')
                //         resolve()
                //     })
            }
        })
    }

    loadBg () {
        return new Promise(resolve => {
            const img = new window.Image()

            img.addEventListener('load', () => {
                this.$bg.css({
                    backgroundImage: `url(${this.bgSrc})`
                })
                resolve()
            })

            img.src = this.bgSrc
        })
    }

    destroy () {
        window.removeEventListener('resize', this.onResize)
        this.$btn.off('click touch', this.onBtnClick)
        this.$cont.remove()
    }

    onBtnClick () {
        if (this.isLock) return
        this.isLock = true
        this.hide()
    }

    hide () {
        if (window.sessionStorage) {
            window.sessionStorage.setItem('ntm', 1)
        }

        this.$body.removeClass('splashscreen-visible')
        this.$cont.trigger('hide')

        TweenMax.to(this.$bg, 0.75, {
            autoAlpha: 0
        })

        TweenMax.to(this.$cont, 0.75, {
            autoAlpha: 0,
            delay: 0.5,
            onComplete: () => {
                this.destroy()
            }
        })
    }

    onResize () {
        this.setValues()
    }

    setValues () {
        // this.$svg.attr('viewBox', `0 0 3800 ${window.innerHeight}`)
        // const y = (window.innerHeight / 2) - 314
        // this.$subSvg.attr('y', `${y}`)
    }
}



// WEBPACK FOOTER //
// ./webpack/js/common/Splashscreen.js